import { pinStyles } from './config';

const getOffset = (zoom) => {
  let offset = 0;

  if (zoom >= 14) {
    offset = 0.005;
  } else if (zoom >= 13 && zoom < 14) {
    offset = 0.03;
  } else if (zoom > 11 && zoom < 13) {
    offset = 0.05;
  } else if (zoom > 5 && zoom <= 11) {
    offset = 0.3;
  } else if (zoom <= 5) {
    offset = 1;
  }

  return offset;
};

function createMarkerPin(iconName = 'pinIcon') {
  const styles = pinStyles[iconName];
  const el = document.createElement('div');
  el.classList.add('marker');

  Object.assign(el.style, styles);

  return el;
}

export { createMarkerPin, getOffset };
